import { render } from "./SurveyQ8.vue?vue&type=template&id=4eff5172&ts=true"
import script from "./SurveyQ8.vue?vue&type=script&lang=ts"
export * from "./SurveyQ8.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__